import React, { FC } from 'react';
import { NewUnitProjectFormProps } from './NewUnitProjectFormProps';
import useTranslation from '../../../hooks/useTranslation';
import Text from '@ingka/text';
import ProjectDetailsFields from '../ProjectDetailsFields';
import ProjectConfidentialButton from '../ProjectConfidentialButton';
import Divider from '../../Divider';
import ProjectDatesFields from '../ProjectDatesFields';
import ProjectInformationFields from '../ProjectInformationFields';
import ProjectProgrammeNameSelect from '../ProjectProgrammeNameSelect';
import PartOfCrpForm from '../PartOfCrpForm';

const NewUnitProjectForm: FC<NewUnitProjectFormProps> = ({
  projectList,
  isConfidentialAllowed,
  isep,
}) => {
  const t = useTranslation();
  return (
    <>
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.projectDetails')}
      </Text>
      <ProjectDetailsFields
        projectList={projectList}
        unifier={isep}
        type={'New Unit'}
      />
      {isConfidentialAllowed && <ProjectConfidentialButton />}
      <Divider />
      <PartOfCrpForm />
      <Divider />
      <ProjectInformationFields />
      <Divider />
      <ProjectDatesFields
        openingDate
        initialDates
        projectClosingDate
        isep={isep}
      />
      <Divider />
      <ProjectProgrammeNameSelect />
    </>
  );
};

export default NewUnitProjectForm;
